if (document.querySelectorAll('.facets__disclosure')) {

  //click event listener for each filter option that may be present
  document.querySelectorAll('.facets__disclosure').forEach(arrow => {
    arrow.addEventListener('click', event => {
      
      if(arrow.querySelector('.icon-caret')) {
        //rotate arrow animation
        var caret = arrow.querySelector('.icon-caret');
        caret.classList.toggle("arrow-rotate");
      }
    });
  });
}